import type { PlaneSize } from '@Components/BigBrowse/Model/ModelTypes';
import { makeModeFillVideo } from '@Utils/make-mode-fill';
import { a, useSpring } from '@react-spring/three';
import { useVideoTexture } from '@react-three/drei';
import React, { Suspense, useEffect } from 'react';

type Props = {
  src: string;
  containerSize: PlaneSize;
  onLoad?: () => void;
  opacity?: number;
  sourceSize?: PlaneSize;
};
export function VideoMaterial({
  src,
  containerSize,
  onLoad,
  opacity = 1,
  sourceSize,
}: Props) {
  const texture = useVideoTexture(src, {
    unsuspend: 'canplay',
    crossOrigin: 'Anonymous',
    muted: true,
    loop: true,
    start: true,
    autoplay: true,
  });

  useEffect(() => {
    if (texture) {
      makeModeFillVideo({
        planeSize: containerSize,
        tex: texture,
        sourceSize,
      });
      onLoad?.();
    }

    return () => {
      texture.dispose();
    };
  }, [texture]);

  const { opacityAnim } = useSpring({
    from: { opacityAnim: 0 },
    to: { opacityAnim: opacity },
    config: { duration: 1000 },
  });

  return (
    <Suspense>
      {/* @ts-expect-error*/}
      <a.meshBasicMaterial map={texture} transparent opacity={opacityAnim} />
    </Suspense>
  );
}
